// extracted by mini-css-extract-plugin
module.exports = {"actions":"ErrorDialog_actions__5cmig","action":"ErrorDialog_action__a8M7q"};